<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ប្រវត្តិទូទាត់ប្រាក់</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-40">
								<md-field>
									<label>ស្វែងរកប្រត្តិបត្តិការតាមរយៈលេខកូដ ឬ ពាក្យសំគាល់</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<!-- <div class="md-layout-item md-small-size-100 md-size-30">
								<md-field>
									<label>ឈ្មោះប្រតិបត្តិការ</label>
									<md-select placeholder="ឈ្មោះប្រតិបត្តិការ (ទាំងអស់)" v-model="search.tag">
										<md-option value="">ទាំងអស់</md-option>
										<md-option v-for="tag in tagList" :value="tag.id">{{tag.name}}</md-option>
									</md-select>
								</md-field>
							</div> -->
							<div class="md-layout-item md-size-30">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
								</md-button>
							</div>
						</div>
						<md-table v-if="transactionList.length > 0">
							<md-table-row>
								<md-table-head>ល.រ</md-table-head>
								<md-table-head>លេខកូដ</md-table-head>
								<md-table-head>ប្រភេទប្រតិបត្តិការ</md-table-head>
								<md-table-head>ចំនួន</md-table-head>
								<md-table-head>កំណត់ចំណាំ</md-table-head>
								<md-table-head>បង្កើតដោយ</md-table-head>
								<md-table-head>សកម្មភាព</md-table-head>
							</md-table-row>
			
							<md-table-row v-for="(transaction, index) in transactionList">
								<md-table-cell>{{ index + 1 }}</md-table-cell>
								<md-table-cell>{{ transaction.hash }}<br>{{ transaction.name }}</md-table-cell>
								<md-table-cell>
									<span class="green" v-if="transaction.type == 'dep'">ដាក់ប្រាក់</span>
									<span class="late" v-if="transaction.type == 'withdraw'">ដកប្រាក់</span>
								</md-table-cell>
								<md-table-cell>{{ config.moneylify(transaction.amount) }}</md-table-cell>
								<md-table-cell>{{ transaction.note }}</md-table-cell>
			
								<md-table-cell>{{transaction.created_by}}<br>{{ config.datelify(transaction.created_date)[1] }}</md-table-cell>
								<md-table-cell><router-link :to="'/print_partner_payment/' + transaction.hash">
									<md-button class="md-just-icon md-simple md-primary">
										<md-icon>visibility</md-icon>
										<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
									</md-button>
								</router-link></md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell></md-table-cell>
								<md-table-cell></md-table-cell>
								<md-table-cell></md-table-cell>
								<md-table-cell colspan="2">
									<b>{{ config.moneylify(total_transaction)}}</b>
								</md-table-cell>
								<md-table-cell></md-table-cell>
								<md-table-cell></md-table-cell>
							</md-table-row>
						</md-table>
			
						<h4 class="text-center" v-if="transactionList.length == 0">មិនមានប្រតិបត្តិការ</h4>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		mounted() {
			// if (this.$store.state.authentication.account_type == 'ca') {
			// 	this.$router.push('/dashboard');
			// }
		},
		created() {
			this.searchHandler();
			// this.getSettings();
		},
		computed: {
			total_transaction() {
				let total = 0;
				for(let i = 0; i< this.transactionList.length; i++) {
					total = total + this.transactionList[i].amount;
				}
				return total;
			}
		},
		data() {
			return {
				loaded: true,
				search: { text: "", tag: "" },
				loadMore: false,
				tagList: [],
				transactionList: []
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.tagList = data.body.data.tag
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/user/transaction/search", {
					text: this.search.text,
					tag: this.search.tag,
					offset: more ? this.transactionList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 50) this.loadMore = true;
					else this.loadMore = false;
					this.transactionList = more ? this.transactionList.concat(data.body.data) : data.body.data;
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Transactions/View.vue